





















































































import { Vue, Component } from 'vue-property-decorator'

@Component
export default class ChatControl extends Vue {
    chatClosingDelay = 0
    adminComment = {
        name: "Ylläpitäjä",
        message: "",
        isAdmin: true
    }
    ChangeChatStatus (status: object) {
      this.socket.emit("chat_status", status)
    }
    submitAdminComment(): void {
      this.socket.emit("submit_comment", this.adminComment)
    }
    deleteComment(id:string): void {
      this.socket.emit("delete_comment", id);
    }
    parseChatDate(date:string): string {
          let d = new Date(date);
          const h = d.getHours();
          const m = d.getMinutes();
          const s = d.getSeconds();

          const hours = h < 10 ? "0" + h : h;
          const minutes = m < 10 ? "0" + m : m;
          const seconds = s < 10 ? "0" + s : s;

          return `${hours}:${minutes}:${seconds}`;
    }
    get event(): any {
        return this.$store.state.event;
    }
    get socket(): any {
        return this.$store.state.socket;
    }
    get reverseComments(): Array<any> {
      if(!this.event.comments) return [];
      return this.event.comments.slice().filter((c:any) => !c.isDeleted).reverse();
    }
    get isChatEnabled() {
        if(!this.event.chatStatus) return false;

        const status = this.event.chatStatus.status;
        if(status === 'open') return false;
        return true;
    }
}
